<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="dedication1">To the memory<span epub:type="pagebreak" id="pagev"></span></p>
<p class="dedication2">of</p>
<p class="dedication3"><img alt="" class="image" src="images/ufig_1.jpg"/></p>
<p class="dedication2">R.123313 Flight Sergeant Kenneth Earl Clifford Slack RCAF,</p>
<p class="dedication2">433 (Porcupine) Squadron, Royal Canadian Air Force,</p>
<p class="dedication2">who, aged 21, gave his life on 8 May 1945 whilst</p>
<p class="dedication2">trying to save a German guard from drowning</p>
<p class="dedication2">in the River Elbe near Schönebeck,</p>
<p class="dedication2">and to the hundreds of his fellow prisoners-of-war</p>
<p class="dedication2">who also should have returned home.</p>
<p class="dedication4">‘Lives of great men all remind us<br/>We can make our lives sublime,<br/>And, departing, leave behind us<br/>Footprints on the sands of time.’</p>
<p class="dedication2">H.W. Longfellow (1807-1882)<span epub:type="pagebreak" id="pagevi"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?395ef6cf